<template lang="pug">
  .delivery-address(v-if="data.step=='delivery-address'")
    .delivery-address__left
      //.delivery-address__left-notification Внимание! Доставка не осуществляется. Только самовывоз.
      .delivery-address__left-title Бесплатная доставка от 500 ₽. При заказе до 500 ₽ доставка 100 ₽
      //.delivery-address__left-text Стоимость доставки в другие районы города уточняйте у менеджера
      .delivery-address__left-map-wr
        .delivery-address__left-map.js-delivery-address__left-map
          .delivery-address__left-map-preloader
    .delivery-address__right
      form.delivery-address__right-form(@submit.prevent="sendDeliveryAddress")
        .delivery-address__right-form-row
          input(type="hidden", name="city", value="Краснодар")
          label.delivery-address__right-form-label Имя*
            input.delivery-address__right-form-input(type="text", name="fio", placeholder="Введите имя", required, data-uni-tips-type="fio.name", autocomplete="off")
          label.delivery-address__right-form-label E-mail*
            input.delivery-address__right-form-input(type="email", name="email", placeholder="Введите e-mail", required, data-uni-tips-type="email" autocomplete="off")
        .delivery-address__right-form-row
          label.delivery-address__right-form-label Телефон*
            input.delivery-address__right-form-input(type="tel", v-model="phone", name="phone", v-mask="'+7(###)-###-##-##'", placeholder="+7(___)-___-__-__", required)
          label.delivery-address__right-form-label Количество персон*
            input.delivery-address__right-form-input(type="text", v-model="countPerson", name="countPerson", placeholder="Введите количество персон", required)
        .delivery-address__right-form-row
          label.delivery-address__right-form-label Улица*
            input.delivery-address__right-form-input(type="text", name="street", placeholder="Введите название улицы", required, data-uni-tips-type="address:street", data-location-city="city", autocomplete="off")
        .delivery-address__right-form-row
          label.delivery-address__right-form-label Дом*
            input.delivery-address__right-form-input(type="text", name="house", placeholder="Введите номер дома", required, data-uni-tips-type="address:house", data-location-city="city", data-location-street="street", autocomplete="off")
          label.delivery-address__right-form-label Подъезд
            input.delivery-address__right-form-input(type="text", v-model="porch", name="porch", placeholder="Введите номер подъезда")
          label.delivery-address__right-form-label Этаж
            input.delivery-address__right-form-input(type="text", v-model="floor", name="floor", placeholder="Введите этаж")
          label.delivery-address__right-form-label Квартира
            input.delivery-address__right-form-input(type="text", v-model="flat", name="flat", placeholder="Введите номер квартиры")
        .delivery-address__right-form-row
          label.delivery-address__right-form-label Комментарии к заказу:
            textarea.delivery-address__right-form-textarea(name="comment", v-model="comment", placeholder="Введите комментирии к заказу")
        .delivery-address__right-form-description Нажимая кнопку «Далее», Вы даёте согласие на&nbsp;
          router-link.delivery-address__right-form-description-link(to="/politika-konfidencialnosti", target="_blank") обработку персональных данных
        .delivery-address__right-buttons
          router-link.delivery-address__right-buttons-back(to="/korzina/vash-zakaz") Назад
          button.delivery-address__right-buttons-next(type="submit") Далее
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/deliveryAddress/deliveryAddress.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import {YaHelpersVue} from '@/mixins/YaHelpersVue';
import {CartHelpersVue} from '@/mixins/CartHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'DeliveryAddress',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, YaHelpersVue, CartHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {
      isMapInit: false,
      phone: "",
      countPerson: "",
      porch: "",
      floor: "",
      flat: "",
      comment: "",
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    if(this.checkProperty(this.data.fields)) {
      this.phone = this.data.fields.phone || '';
      this.countPerson = this.data.fields.countPerson || '';
      this.porch = this.data.fields.porch || '';
      this.floor = this.data.fields.floor || '';
      this.flat = this.data.fields.flat || '';
      this.comment = this.data.fields.comment || '';

      this.$nextTick(() => {
        if(this.data.fields.fio) {
          $('.delivery-address__right-form-input[name="fio"]').val(this.data.fields.fio);
        }

        if(this.data.fields.email) {
          $('.delivery-address__right-form-input[name="email"]').val(this.data.fields.email);
        }

        if(this.data.fields.street) {
          $('.delivery-address__right-form-input[name="street"]').val(this.data.fields.street);
        }

        if(this.data.fields.house) {
          $('.delivery-address__right-form-input[name="house"]').val(this.data.fields.house);
        }
      });
    }

    if(this.data.initMapConfig) {
      this.$nextTick(() => {
        if(!this.isMapInit) {
          this.initMapLocal('.js-delivery-address__left-map', this.data.initMapConfig);
        }
      });
    }
  },

  methods: {
    initMapLocal(block, initMapConfig) {
      //console.log(data.initMapConfig);
      this
          .initMap(block, initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                $('.delivery-address__left-map-preloader').addClass('delivery-address__left-map-preloader--hide');
              }, 750);
            });

            this.isMapInit = true;
          });
    },

    sendDeliveryAddress() {
      let params = {
        fio: $('.delivery-address__right-form-input[name="fio"]').val(),
        email: $('.delivery-address__right-form-input[name="email"]').val(),
        phone: this.phone,
        countPerson: this.countPerson,
        street: $('.delivery-address__right-form-input[name="street"]').val(),
        house: $('.delivery-address__right-form-input[name="house"]').val(),
        porch: this.porch,
        floor: this.floor,
        flat: this.flat,
        comment: this.comment,
        cartId: this.getCartId()
      };

      this.saveDeliveryAddress((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          this.cartStep('/korzina/oplata');
        }
      }, params);
    },
  }
}
</script>
